(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_6af3c7a"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cv-magazine-collection')) {
    customElements.define('cv-magazine-collection', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        if (this.dataset.shuffle !== 'true' || this.dataset.editor === 'true') return;

        const grid = this.querySelector('.cv-magazine__grid');
        if (!grid || grid.contains(document.activeElement)) return;
        const cards = Array.from(grid.children).slice(1);
        if (cards.length < 2) return;

        for (let i = cards.length - 1; i > 0; i -= 1) {
          const j = Math.floor(Math.random() * (i + 1));
          [cards[i], cards[j]] = [cards[j], cards[i]];
        }
        const fragment = document.createDocumentFragment();
        cards.forEach(card => fragment.appendChild(card));
        grid.appendChild(fragment);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cozyvibe-customer-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cv-customer-reviews')) {
    customElements.define('cv-customer-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup) return;
        const track = this.querySelector('[data-track]');
        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (!track || !prev || !next) return;
        const cards = Array.from(track.querySelectorAll('[data-card-index]'));
        const update = () => {
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        };
        const move = direction => {
          const candidates = direction > 0 ? cards : cards.slice().reverse();
          const target = candidates.find(card => direction > 0
            ? card.offsetLeft > track.scrollLeft + 2
            : card.offsetLeft < track.scrollLeft - 2);
          if (!target) return;
          track.scrollTo({
            left: target.offsetLeft,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        };
        const back = () => move(-1);
        const forward = () => move(1);
        let frame = 0;
        const onScroll = () => {
          if (frame) return;
          frame = requestAnimationFrame(() => { frame = 0; update(); });
        };
        prev.addEventListener('click', back);
        next.addEventListener('click', forward);
        track.addEventListener('scroll', onScroll, { passive: true });
        const resize = new ResizeObserver(update);
        resize.observe(track);
        update();
        this.cleanup = () => {
          prev.removeEventListener('click', back);
          next.removeEventListener('click', forward);
          track.removeEventListener('scroll', onScroll);
          resize.disconnect();
          cancelAnimationFrame(frame);
        };
      }
      disconnectedCallback() {
        if (this.cleanup) this.cleanup();
        this.cleanup = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
